// ===============================
// LocalStorage helpers
// ===============================
const loadUserFromStorage = () => {
  try {
    const data = localStorage.getItem("user");
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Failed to load user from storage", error);
    return null;
  }
};

const saveUserToStorage = (user) => {
  try {
    localStorage.setItem("user", JSON.stringify(user));
  } catch (error) {
    console.error("Failed to save user to storage", error);
  }
};

const removeUserFromStorage = () => {
  try {
    localStorage.removeItem("user");
  } catch (error) {
    console.error("Failed to remove user from storage", error);
  }
};

// ===============================
// Initial State (rehydrated)
// ===============================
const initialState = loadUserFromStorage() || {
  fullName: "",
  userId: "",
  agencyId: "",
  invitedById: "",
  email: "",
  status: 0,
  isSuperAdmin:false,
  agency_name: "",
  agency_email:"",
  role:""
};

// ===============================
// Action Types
// ===============================
const SET_USER_INFORMATION = "SET_USER_INFORMATION";
const REMOVE_USER_INFORMATION = "REMOVE_USER_INFORMATION";

// ===============================
// Reducer
// ===============================
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFORMATION: {
      const userData = {
        fullName: action.payload.fullName,
        userId: action.payload.userId,
        agencyId: action.payload.agencyId,
        invitedById: action.payload.invitedById,
        email: action.payload.email,
        status: action.payload.status,
        isSuperAdmin: action.payload.isSuperAdmin,
        agency_name: action.payload.agency_name,
        agency_email: action.payload.agency_email,
        role: action.payload.role,
      };

      // persist to localStorage
      saveUserToStorage(userData);

      return {
        ...state,
        ...userData,
      };
    }

    case REMOVE_USER_INFORMATION:
      removeUserFromStorage();
      return {
        fullName: "",
        userId: "",
        agencyId: "",
        invitedById: "",
        email: "",
        status: 0,
        isSuperAdmin:false,
        agency_name: "",
        agency_email:"",
        role:"",
      };

    default:
      return state;
  }
};

// ===============================
// Action Creators
// ===============================
export const setUserInformation = (fullName, userId, email, status, isSuperAdmin, agencyId = null, invitedById = null, agency_name = "", agency_email = "", role = "") => ({
  type: SET_USER_INFORMATION,
  payload: { fullName, userId, email, status, isSuperAdmin, agencyId, invitedById, agency_name, agency_email, role },
});

export const removeUserInformation = () => ({
  type: REMOVE_USER_INFORMATION,
});

export default userReducer;
